<template>
  <card>
    <list
      v-if="$store.state.user.sections['logs']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :setImport="true"
      :exportFields="exportFields"
      :isAdd="false"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Дата: {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        Пользователь: {
          field: "user.phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
        Название: "name",
        Примечание: "description",
        Запрос: "request",
        Ответ: "response",
        Заголовок: "headers",
        Ссылка: "url",
        Тип: "type",
        Статус: "status",
        Версия: "version",
        ID: "id",
        IP: "ip",
        Устройство: "device",
        Вкладка: "tab",
      },
      staticFilters: [],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "user",
          title: "Фильтр по сотрудникам",
          titleKey: "phone",
          field_key: "user",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [
        {
          label: "Номер телефона",
          key: "phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_log",
      itemLink: "logs",
      setLink: "logs",
      columns: [
        {
          key: "user",
          title: "Сотрудник",
          object: "phone",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },

        {
          key: "name",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "description",
          title: "Примечание",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "url",
          title: "Адрес",
          labelKey: "address",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          full: true,
        },
        {
          key: "ip",
          title: "IP",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        // {
        //   key: "response",
        //   title: "Ответ",
        //   checkbox: false,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },

        {
          key: "device",
          title: "Устройство",
          full: true,
        },
        {
          full: true,
          key: "tab",
          title: "Вкладка",
        },
        {
          key: "version",
          title: "VER",
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
